import { useSelector } from 'react-redux';
import { useView } from 'find-and-filter-data/views-data/public';
import { getCurrentViewId } from '../../thread-list/selectors/getCurrentViewId';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
export function useCurrentView() {
  const inboxId = useSelector(getCurrentInboxId);
  const currentViewId = useSelector(getCurrentViewId);
  return useView(inboxId, currentViewId);
}